module.exports = __webpack_public_path__ + "img/wei.11a044e7.svg";